module.exports = __webpack_public_path__ + "img/TG60.png";